import Base from '../Base';

export default class Clearance extends Base {
    static url = '/api/clearance';
}
